import { render, staticRenderFns } from "./search-map.vue?vue&type=template&id=55c0bc2b"
import script from "./search-map.vue?vue&type=script&lang=js"
export * from "./search-map.vue?vue&type=script&lang=js"
import style0 from "./search-map.vue?vue&type=style&index=0&id=55c0bc2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports